import React from 'react';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <h3 className="footer-title">LandaGroup</h3>
        <p className="footer-tagline">La solution numérique pour tous.</p>

        <p style={{marginTop: '15px'}}>
          <a href="mailto:contacts@landagroup.fr" className="footer-email">contacts@landagroup.fr</a>
        </p>

        <p className="footer-copy">© {new Date().getFullYear()} LandaGroup. Tous droits réservés.</p>
      </div>
    </footer>
  );
}
